import { Search } from 'grommet-icons'
import { debounce } from 'lodash'
import { InputHTMLAttributes, useEffect, useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

type Props = {
  searchPlaceholder?: string
  className?: string
  searchKey?: string
} & InputHTMLAttributes<HTMLInputElement>

export const TextSearch = ({ searchPlaceholder, className, searchKey = 'search', ...props }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [value, setValue] = useState(() => searchParams.get(searchKey) || '')
  const updateSearchParam = useMemo(
    () =>
      debounce((val: string) => {
        setSearchParams(prev => {
          const next = new URLSearchParams(prev)
          val ? next.set(searchKey, val) : next.delete(searchKey)
          next.set('page', '1')
          return next
        })
      }, 300),
    [setSearchParams, searchKey]
  )

  const handleSearch = (val: string) => {
    setValue(val)
    updateSearchParam(val)
  }

  useEffect(() => {
    setValue(searchParams.get(searchKey) || '')
  }, [searchParams, searchKey])

  return (
    <div className={`relative flex items-center ${className}`}>
      <div className="absolute left-4 flex items-center pointer-events-none">
        <Search color="black" size="small" />
      </div>
      <input
        className="w-full rounded-full border border-gray-300 py-2.5 pl-11 pr-4 text-sm focus:border-primary focus:outline-none transition-colors"
        onChange={e => handleSearch(e.target.value)}
        placeholder={searchPlaceholder || 'Search....'}
        type="text"
        value={value}
        {...props}
      />
    </div>
  )
}
